'use strict';
module.exports = {};



//////////////////
// WEBPACK FOOTER
// ./node_modules/@twilio/notifications/node_modules/core-js/internals/iterators.js
// module id = 831
// module chunks = 25